import React from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import {
  AdditionalProtectionId,
  AdditionalProtectionsModel,
  SecurityTypes
} from "../../../../helpers/additionalQuestions/additionalProtections";
import TooltipInfo from "../../../sharedComponents/tooltipInfo/tooltipInfo";
import { runInAction } from "mobx";


interface AdditionalProtectionsProps {
  calculateStore?: CalculateStore;
}

export function AdditionalProtections(props: AdditionalProtectionsProps) {

  const calculateStore = props.calculateStore!;

  const onChange = (event: React.MouseEvent<HTMLElement>, protections: AdditionalProtectionId[]) => {
    setAdditionalProtectionValues(protections);
  };

  function getCheckedProtections(): AdditionalProtectionId[] {
    const protections = calculateStore.additionalQuestions.additionalProtections;
    let protectionsChecked: AdditionalProtectionId[] = [];

    protectionsChecked = addProtectinIfChecked(protectionsChecked, protections.antiburglarDoors, AdditionalProtectionId.antiburglarDoors);
    protectionsChecked = addProtectinIfChecked(protectionsChecked, protections.antiburglarInstallation, AdditionalProtectionId.antiburglarInstallation);
    protectionsChecked = addProtectinIfChecked(protectionsChecked, protections.caretaker, AdditionalProtectionId.caretaker);
    protectionsChecked = addProtectinIfChecked(protectionsChecked, protections.fireExtinguishing, AdditionalProtectionId.fireExtinguishing);
    protectionsChecked = addProtectinIfChecked(protectionsChecked, protections.firefightingInstallation, AdditionalProtectionId.firefightingInstallation);
    protectionsChecked = addProtectinIfChecked(protectionsChecked, protections.securityWindows, AdditionalProtectionId.securityWindows);

    return protectionsChecked;
  }

  function addProtectinIfChecked(protectionsChecked: AdditionalProtectionId[], checked: boolean, protectionId: AdditionalProtectionId) {
    if (checked) {
      protectionsChecked = [...protectionsChecked, protectionId];
    }
    return protectionsChecked;
  }

  function setAdditionalProtectionValues(protections: AdditionalProtectionId[]) {
    const additionalProtections: AdditionalProtectionsModel = calculateStore.additionalQuestions.additionalProtections;
    runInAction(() => {
      // TODO: create setter and remove 'runInAction'
      additionalProtections.antiburglarDoors = isChecked(protections, AdditionalProtectionId.antiburglarDoors);
      additionalProtections.antiburglarInstallation = isChecked(protections, AdditionalProtectionId.antiburglarInstallation);
      additionalProtections.caretaker = isChecked(protections, AdditionalProtectionId.caretaker);
      additionalProtections.fireExtinguishing = isChecked(protections, AdditionalProtectionId.fireExtinguishing);
      additionalProtections.firefightingInstallation = isChecked(protections, AdditionalProtectionId.firefightingInstallation);
      additionalProtections.securityWindows = isChecked(protections, AdditionalProtectionId.securityWindows);
      calculateStore.setAdditionalProtections(additionalProtections);
    });
  }

  function isChecked(protections: AdditionalProtectionId[], protectionType: AdditionalProtectionId) {
    for (const index in protections) {
      if (protections[index] === protectionType.toString()) {
        return true;
      }
    }
    return false;
  }

  const renderedAdditionalProtections: JSX.Element[] = [];

  SecurityTypes.forEach((security) => {
    renderedAdditionalProtections.push(
      <ToggleButton
        value={security.additionalProtection}
        className="button"
        key={security.additionalProtection}
      >
        {security.icon}
        {security.displayName}
      </ToggleButton>
    );
  });

  const question = {
    text: "Dodatkowe zabezpieczenia",
    contextHelp: `<div>
               <p>Drzwi antywłamaniowe - drzwi zgodnie z klasą odporności na włamanie co najmniej 3.</p>
                <p>Stały dozór ochrony - stały dozór miejsca ubezpieczenia pełniony przez  pracowników agencji ochrony mienia.</p>
                <p>Alarm z powiadomieniem - system antywłamaniowy obejmujący swym zasięgiem całą powierzchnię domu lub mieszkania i wywołujący alarm w jednostce policji lub agencji ochrony mienia.</p>
                <p>Zabezpieczenia okien - kraty lub rolety antywłamaniowe zgodnie z klasą odporności na włamanie co najmniej 2 lub szyby zgodnie z klasą odporności na włamanie co najmniej P3.</p>
                <p>Przeciwpożarowa instalacja sygnalizacyjna powiadamiająca agencję ochrony lub straż pożarną.</p>
            </div>`
  };

  return (
    <div className="additional-questions-section additional-protections">
      <div className="toggle-button-group">
        <div className="question-answer-container">
          <div className="question">{question.text}
            <div className="tooltip">
              <TooltipInfo infoMessage={question.contextHelp} />
            </div>
          </div>
          <ToggleButtonGroup className="toggle"
            value={getCheckedProtections()}
            onChange={onChange}
          >
            {renderedAdditionalProtections}
          </ToggleButtonGroup>
        </div>
      </div>
    </div>
  );
}

export default inject("calculateStore")(observer(AdditionalProtections));
